import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Link,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import lineIcon from "../../images/lineIcon.png";
import facebookIcon from "../../images/facebookIcon.png";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";

const ContactModal = ({ open, onClose }) => {
  const [cusTel, setCusTel] = useState("");
  const [product24, setProduct24] = useState("");
  const [product25, setProduct25] = useState("");
  const [product26, setProduct26] = useState("");
  const [product27, setProduct27] = useState("");
  const [product28, setProduct28] = useState("");

  useEffect(() => {
    if (open) {
      getContactInfo();
    }
  }, [open]);

  const getContactInfo = async () => {
    try {
      const result = await getParameterAPI(24);
      const payload = result.payload;

      payload.forEach((item, index) => {
        if (index === 23) setProduct24(item.variable1 || ""); // Email link
        if (index === 24) setProduct25(item.variable1 || ""); // LINE link
        if (index === 25) setProduct26(item.variable1 || ""); // Facebook link
        if (index === 26) setProduct27(item.variable1 || ""); // Phone link
        if (index === 27) setProduct28(item.variable1 || ""); // Emergency phone link
      });

      // Get customer service telephone
      const result12 = await getParameterAPI(12);
      const payload12 = result12.payload;
      const cusTelData = payload12.find((item) => item.code === "CUS_SERV_TEL");
      setCusTel(cusTelData?.variable1 || "02-648-3600");
    } catch (error) {
      console.error("Error fetching contact info:", error);
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const digits = phone.replace(/\D/g, ""); // ลบตัวอักษรที่ไม่ใช่ตัวเลขออก
    if (digits.length === 10) {
      return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
    } else if (digits.length === 9) {
      // กรณีเบอร์โทรบ้านบางพื้นที่มี 9 หลัก
      return `${digits.slice(0, 2)}-${digits.slice(2, 5)}-${digits.slice(5)}`;
    }
    return phone;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 0,
          maxWidth: "700px !important",
          width: "90% !important",
          margin: "auto !important",
        },
      }}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        "& .MuiDialog-container": {
          alignItems: "center !important",
          justifyContent: "center !important",
        },
        "& .MuiDialog-paper": {
          maxWidth: "700px !important",
          width: "90% !important",
          m: 2,
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          zIndex: 1,
          color: "#999",
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          p: 4,
          pt: 5,
          maxWidth: "none !important",
          width: "100% !important",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            color: "#fb5e3f",
            fontSize: "1.5rem",
            fontFamily: "Prompt-Thin"
          }}
        >
          ติดต่อฝ่ายลูกค้าสัมพันธ์
        </Typography>
        <hr
          style={{
            border: "solid 1px",
            borderTop: "1px solid #e0e0e0",
            marginBottom: "16px",
          }}
        />
        <Box sx={{ mb: 2.5 }}>
          <Typography sx={{ mb: 1, lineHeight: 1.8, fontSize: "1.05rem" }}>
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>Call</span>{" "}
            <Link href={product27} underline="hover" sx={{ color: "#fb5e3f", fontWeight: "bold" }}>
              {formatPhoneNumber(cusTel)}
            </Link>
            {" : "}เวลาทำการ วันจันทร์ - ศุกร์ เวลา 08.00 - 17.00 น.
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#666", pl: 0 }}>
            (เว้นวันหยุดราชการและวันหยุดประจำปี)
          </Typography>
        </Box>
        <Typography sx={{ mb: 2.5, lineHeight: 1.8, fontSize: "1.05rem" }}>
          <span style={{ fontWeight: "bold", fontSize: "18px" }}>LINE</span>{" "}
          <Link href={product25} underline="hover" sx={{ color: "#fb5e3f", fontWeight: "bold" }}>
            @rabbit_life
          </Link>
          {" : "}เปิดให้บริการทุกวัน เวลา 08.00 - 21.00 น.
        </Typography>
        <Typography sx={{ mb: 2.5, lineHeight: 1.8, fontSize: "1.05rem" }}>
          <span style={{ fontWeight: "bold", fontSize: "18px" }}>Email</span>
          {" : "}
          <Link href={product24} underline="hover" sx={{ color: "#fb5e3f", fontWeight: "bold" }}>
            cs@rabbitlife.co.th
          </Link>
        </Typography>
        {/* <Typography sx={{ mb: 2.5, lineHeight: 1.6 }}>
          <span style={{ fontWeight: "bold", fontSize: "16px" }}>
            แจ้งอุบัติเหตุฉุกเฉิน 24 ชั่วโมง
          </span>
          {": "}
          <Link href={product28} underline="hover" sx={{ color: "#fb5e3f", fontWeight: "bold" }}>
            02-494-7005
          </Link>
        </Typography> */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.5, mt: 3 }}>
          <a href={product26} target="_blank" rel="noopener noreferrer">
            <img
              src={facebookIcon}
              alt="Facebook"
              style={{ width: "50px", height: "50px", cursor: "pointer" }}
            />
          </a>
          <a href={product25} target="_blank" rel="noopener noreferrer">
            <img
              src={lineIcon}
              alt="LINE"
              style={{ width: "50px", height: "50px", cursor: "pointer" }}
            />
          </a>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
